import React, { useContext, useEffect, useState } from "react";
import useSpeechToText from "./useSpeechToText";
import Micro from "../../assets/icons/mic.svg";
import Cancle from "../../assets/icons/icon_stop.svg";
import { MyContext } from "../../context/MyContext";
import { useLocation } from "react-router-dom";

const BasicSpeech = ({ onUpdateTranscript }) => {
  const pathname = useLocation();
  const { user, setIsOpenTicketAlert } = useContext(MyContext);
  const [speechError, setSpeechError] = useState("");

  const {
    listening,
    startListening,
    stopListening,
    browserSupportsSpeechRecognition,
  } = useSpeechToText(onUpdateTranscript);

  // 브라우저가 음성인식을 지원하는지 확인
  useEffect(() => {
    if (browserSupportsSpeechRecognition) {
      setSpeechError("");
    } else {
      setSpeechError("Your browser does not support speech recognition");
    }
  }, [browserSupportsSpeechRecognition]);

  // 음성인식 버튼 핸들러
  const micBtnHandler = () => {
    if (listening) return stopListening();

    const hasTutorTicket =
      !pathname.pathname.includes("socrates") && user?.tutor_cnt;
    const hasSocraTicket =
      pathname.pathname.includes("socrates") && user?.socra_cnt;
    const isPossibleToUseService = hasTutorTicket || hasSocraTicket;

    if (!isPossibleToUseService) {
      setIsOpenTicketAlert(true);

      return;
    }

    startListening();
  };

  return (
    <div
      onClick={micBtnHandler}
      disabled={listening}
      className={`voice-wrapper crs-btn ${listening ? "listening" : ""}`}
    >
      <img
        style={{ opacity: 1, transition: "opacity ease 1s" }}
        className="voice-wrapper__icon"
        src={listening ? Cancle : Micro}
        alt="voice-input"
      />
      {speechError !== "" && (
        <p className="mt-4 text-[12px] md:text-[15px]">{speechError}</p>
      )}
    </div>
  );
};

export default BasicSpeech;
